var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudDone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "cloud_done"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_284_11176",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 100,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_284_11176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cloud_done_2",
    d: "M43.125 70.8332L66.6666 47.2915L60.625 41.2498L43.0208 58.854L34.2708 50.104L28.3333 56.0415L43.125 70.8332ZM27.0833 83.3332C20.7638 83.3332 15.3645 81.1457 10.8854 76.7707C6.40621 72.3957 4.16663 67.0484 4.16663 60.729C4.16663 55.3123 5.79857 50.4859 9.06246 46.2498C12.3263 42.0137 16.5972 39.3054 21.875 38.1248C23.6111 31.7359 27.0833 26.5623 32.2916 22.604C37.5 18.6457 43.4027 16.6665 50 16.6665C58.125 16.6665 65.0173 19.4964 70.677 25.1561C76.3368 30.8158 79.1666 37.7082 79.1666 45.8332C83.9583 46.3887 87.934 48.4547 91.0937 52.0311C94.2534 55.6075 95.8333 59.7915 95.8333 64.5832C95.8333 69.7915 94.0104 74.2186 90.3645 77.8644C86.7187 81.5103 82.2916 83.3332 77.0833 83.3332H27.0833ZM27.0833 74.9998H77.0833C80 74.9998 82.4652 73.9929 84.4791 71.979C86.493 69.9651 87.5 67.4998 87.5 64.5832C87.5 61.6665 86.493 59.2012 84.4791 57.1873C82.4652 55.1734 80 54.1665 77.0833 54.1665H70.8333V45.8332C70.8333 40.0693 68.802 35.1561 64.7395 31.0936C60.677 27.0311 55.7638 24.9998 50 24.9998C44.2361 24.9998 39.3229 27.0311 35.2604 31.0936C31.1979 35.1561 29.1666 40.0693 29.1666 45.8332H27.0833C23.0555 45.8332 19.618 47.2568 16.7708 50.104C13.9236 52.9512 12.5 56.3887 12.5 60.4165C12.5 64.4443 13.9236 67.8818 16.7708 70.729C19.618 73.5762 23.0555 74.9998 27.0833 74.9998Z",
    fill: "#188803"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDone);
export default __webpack_public_path__ + "static/media/cloud_done.7bcc1a8d84e9101431a67f8d6939b71a.svg";
export { ForwardRef as ReactComponent };